/* src/features/5DD/ArchiveModal.js */
import React, { useState } from 'react';
import { aiService } from '../../services/ai'; // <--- 1. Import AI Service

const styles = {
  overlay: {
    position: 'fixed', top: 0, left: 0, right: 0, bottom: 0,
    backgroundColor: 'rgba(0,0,0,0.85)', zIndex: 1000,
    display: 'flex', justifyContent: 'center', alignItems: 'center'
  },
  container: {
    backgroundColor: '#fff', padding: '25px', borderRadius: '8px',
    maxWidth: '400px', width: '90%', textAlign: 'center', color: '#333'
  },
  input: {
    width: '100%', padding: '10px', margin: '15px 0',
    borderRadius: '4px', border: '1px solid #ccc', fontSize: '1em'
  },
  buttons: { display: 'flex', gap: '10px', justifyContent: 'center' },
  btnConfirm: {
    padding: '10px 20px', backgroundColor: '#d9534f', color: '#fff',
    border: 'none', borderRadius: '4px', cursor: 'pointer', fontWeight: 'bold'
  },
  btnConfirmDisabled: { // <--- Added disabled style
    padding: '10px 20px', backgroundColor: '#e57373', color: '#eee',
    border: 'none', borderRadius: '4px', cursor: 'wait' 
  },
  btnCancel: {
    padding: '10px 20px', backgroundColor: '#ccc', color: '#333',
    border: 'none', borderRadius: '4px', cursor: 'pointer'
  }
};

function ArchiveModal({ isOpen, onClose, onConfirm, session, activeCourseId }) { // <--- 2. Add Props
  const [note, setNote] = useState('');
  const [isProcessing, setIsProcessing] = useState(false); // <--- 3. Loading State

  if (!isOpen) return null;

  const handleArchive = async () => {
    if (isProcessing) return; // Prevent double clicks

    setIsProcessing(true);

    try {
        // 4. Trigger AI Synthesis (if IDs are present)
        // We await this so the DB is updated with the story BEFORE the page reloads
        if (session?.user?.id && activeCourseId) {
            await aiService.generateCourseSummary(activeCourseId, session.user.id);
        }
    } catch (error) {
        console.error("AI Generation Warning:", error);
        // We continue to archive even if AI fails (don't block the user)
    }

    // 5. Complete the Archive (Parent reloads page)
    onConfirm(note);
  };

  return (
    <div style={styles.overlay}>
      <div style={styles.container}>
        <h3>Wrap Up This Course</h3>
        <p>Add a short note to remember this 5-day block (e.g., "No Sugar Week" or "Focus on Sleep").</p>
        
        <input 
          style={styles.input}
          placeholder="Enter a note..."
          value={note}
          onChange={(e) => setNote(e.target.value)}
          autoFocus
          disabled={isProcessing} // Disable input while processing
        />

        <div style={styles.buttons}>
																			
          <button 
            style={styles.btnCancel} 
            onClick={onClose}
            disabled={isProcessing}
          >
            Cancel
          </button>
          
          <button 
            style={isProcessing ? styles.btnConfirmDisabled : styles.btnConfirm} 
            onClick={handleArchive}
            disabled={isProcessing}
          >
            {isProcessing ? 'Generating Story...' : 'Archive & Reset'}
          </button>
        </div>
      </div>
    </div>
  );
}

export default ArchiveModal;